module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[],"excludePattern":"(excluded-link|external)"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"한탄강슬로우투어","short_name":"한탄강투어","description":"경기도 포천시 한탄강에서 즐기는 지질체험, 생태관광, 힐링여행","start_url":"/","background_color":"#ffffff","theme_color":"#059669","display":"standalone","icon":"static/favicon.png","lang":"ko","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4d319940636abd18874294eef4f04669"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
